import { config } from "@/config/env";

export interface TrendData {
    value: number;
    trend: number;
    trendLabel: string;
}

export interface VideoQueueStatus {
    pending: number;
    processing: number;
    completed_24h: number; // mapped from completed_24h in backend
    failed: number;
}

export interface SubscriptionPlanStats {
    plan: string;
    users: number;
    mrr: number;
    percentage: number;
}

export interface DashboardOverviewResponse {
    systemStatus: "healthy" | "degraded" | "down";
    totalUsers: TrendData;
    totalVideos: TrendData;
    mrr: TrendData;
    activeJobs: TrendData;
    videoQueue: VideoQueueStatus;
    subscriptionDistribution: SubscriptionPlanStats[];
}

export type DashboardPeriod = "24h" | "7d" | "30d" | "90d" | "year" | "all";

const API_BASE_URL = config.apiUrl;

async function fetchWithAuth(path: string, token: string, options: RequestInit = {}) {
    const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        ...options.headers,
    };

    const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `API Error: ${response.status} ${response.statusText}`);
    }

    return response.json();
}

export const dashboardApi = {
    getOverview: (token: string, period?: DashboardPeriod) =>
        fetchWithAuth(`/admin/dashboard/overview?period=${period || '30d'}`, token).then((res) => res as DashboardOverviewResponse),
};
